import { memo } from 'react';

import * as css from './styles.module.scss';

const ArticleHeader = ({ title, summary }: { title: string; summary: string }) => {
  return (
    <header className={css.header}>
      <h2>{title}</h2>
      <p>{summary}</p>
    </header>
  );
};

export default memo(ArticleHeader);
